<template>
  <div class="error-container">
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-12 align-self-center">
          <div class="text-center">
            <div class="text-center">
              <img
                src="@/assets/img/icons/connection-lost.svg"
                height="85"
                width="85"
                alt="Connection Lost"
              />
              <h3>Connectivity Issue!</h3>
            </div>
            <p>
              We’re having trouble connecting to the server. This might be due
              to a network issue or the server being temporarily unavailable.
            </p>
            <p>
              Please check your internet connection or try again in a few
              moments.
            </p>
            <div class="text-center">
              <router-link to="/" class="btn-black-lg px-5"
                >Back To Home</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {},
  beforeMount() {},
  mounted() {},
};
</script>

<style>
.error-container h1 {
  font-size: 75px;
  line-height: 1;
  margin-bottom: 5px;
  font-weight: bolder;
}
.error-container p {
  font-size: 18px;
  margin-bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Error/ConnectionTimeout.vue